import { render, staticRenderFns } from "./CreateOfficeTransfersModal.vue?vue&type=template&id=30475d81&"
import script from "./CreateOfficeTransfersModal.vue?vue&type=script&lang=js&"
export * from "./CreateOfficeTransfersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports